import React from "react";
import { Helmet } from "react-helmet";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import GuideCard from "../../../../components/Universal/GuideCard.component";
import "../../../../styles/Pages/Financial/CashOutFlow/ResidentialEx/ResidentialEx.style.css";

const Body = ({ ResidentialEx }) => {
  return (
    <section className="ResidentialExContainer">
      <Helmet>
        <title>Residential Ex.</title>
        <meta
          name="description"
          content="Monitor and analyze cash inflow trends and contributions."
        />
        <meta
          name="keywords"
          content="cash inflow, financial dashboard, cash flow analysis, business finance"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <PageHeader title={"Residential Ex."} />
      <div className="ResidentialExGuideCardContainer">
        {ResidentialEx.map((item, index) => {
          return (
            <GuideCard
              key={index}
              title={item?.title}
              description={item?.description}
              image={item?.image}
              link={item?.link}
            />
          );
        })}
      </div>
    </section>
  );
};

export default Body;
